<template>
    <div class="intelligence-table">
        <h3 class="intelligence-table__title">{{ $t('pages.intelligence.charts.reason_ranking') }}</h3>
        <div v-if="reasons.length" class="intelligence-table__wrapper">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('pages.intelligence.constraints.table.reason_code') }}</th>
                        <th>{{ $t('pages.intelligence.constraints.table.frequency') }}</th>
                        <th>{{ $t('pages.intelligence.constraints.table.percent') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in reasons" :key="row.reasonCode">
                        <td>{{ row.reasonCode }}</td>
                        <td>{{ row.count }}</td>
                        <td>{{ row.percent }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="intelligence-table__empty">{{ $t('pages.intelligence.constraints.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            reasons: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-table {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-table__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-table__wrapper {
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    th,
    td {
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
    }

    th {
        color: #6b7280;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
    }

    td:first-child {
        font-family: monospace;
        color: #1e3a8a;
    }

    .intelligence-table__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
